import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const ApplicationsComponent = lazy(() => import('./applications.tsx'));

export const applicationsRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <ApplicationsComponent />
      </Suspense>
    )
  }
];
